import { useState } from "react";
import { useSelector } from "react-redux";
import interested from "../../utils/interested.json";
import "./FiltreProfile.css";

const FiltreProfile = ({ openFiltre }) => {
  const [topics, setTopics] = useState("Select Topic");
  const [showTopics, setShowTopics] = useState(false);
  const [downloads, setDownloads] = useState("All Shots");
  const [showDownloads, setShowDownloads] = useState(false);
  const { topicVideos } = useSelector((state) => state.topic);
  const [topicsCategories] = useState(
    topicVideos.length ? topicVideos : interested
  );

  const chooseDropdownTopics = (e) => {
    setTopics(e.target.innerText);
    setShowTopics((showTopics) => !showTopics);
  };
  const chooseDropdownDownloads = (e) => {
    setDownloads(e.target.innerText);
    setShowDownloads((showTopics) => !showTopics);
  };
  return (
    <div className={`filtreProfile flex-row ${openFiltre && "open"}`}>
      <div className="filtreProfile__achievementFilterTags flex-column">
        <label htmlFor="tags">Tags</label>
        <div className="filtreProfile__achievementFilterTagsInput">
          <svg
            width="24"
            height="24"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              r="6.2"
              transform="matrix(-0.819152 0.573576 0.573576 0.819152 13.4948 12.4952)"
              stroke="#757679"
              strokeWidth="2"
            />
            <rect
              width="2"
              height="7.13287"
              rx="1"
              transform="matrix(-0.819152 0.573576 0.573576 0.819152 17.6426 16.6729)"
              fill="#757679"
            />
          </svg>
          <input type="text" id="tags" />
        </div>
      </div>
      <div className="filtreProfile__achievementFilterColor flex-column">
        <label htmlFor="tags">Color</label>
        <input type="text" id="tags" />
      </div>
      <div className="filtreProfile__achievementFilterTopics">
        <label htmlFor="Topics">Topics</label>
        <div className="filtreProfile__dropdown">
          <div
            className={`dropdown-container flex-row ${showTopics && "expand"}`}
            onClick={() => setShowTopics((showTopics) => !showTopics)}
          >
            <p>{topics}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showTopics && "expand"
            }`}
          >
            {topicsCategories.map((topic) => (
              <label
                htmlFor="TopicsOne"
                onClick={chooseDropdownTopics}
                key={topic.id}
              >
                <input
                  type="radio"
                  name="Topics"
                  key={topic.id}
                  id={`Topics${topic.category}`}
                />
                {topic.category}
              </label>
            ))}
          </div>
        </div>
      </div>
      <div className="filtreProfile__achievementFilterDownloads">
        <label htmlFor="downloads">Downloads</label>
        <div className="filtreProfile__dropdown">
          <div
            className={`dropdown-container flex-row ${
              showDownloads && "expand"
            }`}
            onClick={() => setShowDownloads((showDownloads) => !showDownloads)}
          >
            <p>{downloads}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showDownloads && "expand"
            }`}
          >
            <label htmlFor="DownloadsOne">
              <input
                type="radio"
                name="Downloads"
                id="DownloadsOne"
                value="one"
                onChange={chooseDropdownDownloads}
              />
              one
            </label>
            <label htmlFor="DownloadsTwo">
              <input
                type="radio"
                name="Downloads"
                id="DownloadsTwo"
                value="two"
                onChange={chooseDropdownDownloads}
              />
              two
            </label>
            <label htmlFor="DownloadsThree">
              <input
                type="radio"
                name="Downloads"
                id="DownloadsThree"
                value="three"
                onChange={chooseDropdownDownloads}
              />
              three
            </label>
            <label htmlFor="DownloadsFour">
              <input
                type="radio"
                name="Downloads"
                id="DownloadsFour"
                value="four"
                onChange={chooseDropdownDownloads}
              />
              four
            </label>
            <label htmlFor="DownloadsFive">
              <input
                type="radio"
                name="Downloads"
                id="DownloadsFive"
                value="five"
                onChange={chooseDropdownDownloads}
              />
              five
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltreProfile;
